import React from "react";

interface Props {
  className?: string;
}

export const GithubIcon = ({ className }: Props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 0.333008C3.58 0.333008 0 3.85301 0 8.19434C0 11.6683 2.292 14.6143 5.47 15.653C5.87 15.727 6.01667 15.4837 6.01667 15.275C6.01667 15.0883 6.01 14.5937 6.00667 13.9383C3.78133 14.4123 3.312 12.8837 3.312 12.8837C2.948 11.9763 2.422 11.7337 2.422 11.7337C1.69733 11.2463 2.478 11.2563 2.478 11.2563C3.28133 11.311 3.70333 12.0663 3.70333 12.0663C4.41667 13.2683 5.576 12.921 6.03333 12.7203C6.10533 12.2117 6.31133 11.8657 6.54 11.669C4.76333 11.4723 2.896 10.7963 2.896 7.78434C2.896 6.92634 3.206 6.22501 3.71933 5.67501C3.62933 5.47634 3.35933 4.67701 3.78933 3.59434C3.78933 3.59434 4.45933 3.38367 5.98933 4.40034C6.62933 4.22567 7.30933 4.13901 7.98933 4.13501C8.66933 4.13901 9.34933 4.22567 9.98933 4.40034C11.5093 3.38367 12.1793 3.59434 12.1793 3.59434C12.6093 4.67701 12.3393 5.47634 12.2593 5.67501C12.7693 6.22501 13.0793 6.92634 13.0793 7.78434C13.0793 10.8043 11.2093 11.469 9.42933 11.6623C9.70933 11.8983 9.96933 12.3803 9.96933 13.117C9.96933 14.169 9.95933 15.0143 9.95933 15.2697C9.95933 15.4757 10.0993 15.7217 10.5093 15.643C13.71 14.611 16 11.663 16 8.19434C16 3.85301 12.418 0.333008 8 0.333008Z"
      fill="currentColor"
    />
  </svg>
);
